export default {
    CANCER_MAMA: 1,
    CANCER_COLO_UTERO: 2,
    RISCO_CARDIOVASCULAR: 3,
}